<template>
  <el-container class="process-definition-list pagination-list">
    <el-main>
      <div class="content">
        <el-form :inline="true">
          <el-form-item label="关键字">
            <el-input v-model="conditions.keyword" placeholder="请输入关键字" @keyup.enter.native="search" clearable/>
          </el-form-item>
          <el-form-item label="流程分类">
            <el-select v-model="conditions.processCategory" placeholder="请选择" clearable @change="search">
              <el-option
                v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="search" type="primary">查询</el-button>
          </el-form-item>
        </el-form >
        <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%">
          <el-table-column prop="name" label="流程名称" align="center"></el-table-column>
          <el-table-column prop="category" label="流程分类" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="setCandidate(scope.row)" :disabled="isLoadingCandidate">设置节点候选人</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </el-footer>
      </div>
    </el-main>
    <el-dialog class="candidate-manege-dialog" title="候选人设置" :visible.sync="setCandidateBox" width="1000px" :close-on-click-modal="false" center>
      <div class="candidate-set">
        <div class="title"><b>“{{processName}}”流程候选人设置</b></div>
        <el-container>
          <el-aside width="40%" class="aside">
            <ul>
              <li v-for="items in nodeList" :key="items.id" @click="changeNode(items)">
                <el-card :shadow="currentNode.id===items.id?'always':'never'" v-if="items.type!=='noticeUserTask'">
                  <label>{{items.name}}：</label>
                  <div class="candidates">
                    <span>候选人:{{currentNodeTypeLabel(items.candidateType)}}</span>
                    <span class="info" :title="items.text">{{items.text}}</span>
                  </div>
                </el-card>
                <el-card :shadow="currentNode.id===items.id?'always':'never'" v-if="items.type==='noticeUserTask'">
                  <label>{{items.name}}：</label>
                  <div class="candidates">
                    <span>绑定节点:{{getNodeName(items.noticeNodeId)}}</span>
                  </div>

                </el-card>
                </li>
                <li v-if="nodeList.length === 0">暂无节点信息</li>
              </ul>
          </el-aside>
          <el-main class="main">
            <div class="main-header" v-if="currentNode.type!=='noticeUserTask'">
              <label class="node-title">{{currentNode.name}}候选人：</label>
              <el-select v-model="currentNode.candidateType" placeholder="请选择" style="width: 120px" @change="changeCandidate(currentNode.id,currentNode.candidateType)" :disabled="startNodeId===currentNode.id">
                      <el-option
                        v-for="item in candidateTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
              </el-select>
              <span class="main-info" :title="currentNode.text">{{currentNode.text}}</span>
              <el-button v-show="currentNode.candidateType === 'user'" @click="selectPerson(currentNode.id,'user')" :disabled="startNodeId===currentNode.id">选择</el-button>
              <el-button v-show="currentNode.candidateType==='superiors'" @click="selectPerson(currentNode.id,'superiors')">选择</el-button>
            </div>
            <!-- 抄送的属性 -->
            <div class="connection-component send-component" ref="sendComponent" v-if="currentNode.type==='noticeUserTask'">
              <div v-for="(bound, boundIndex) in bounds" :key="bound.id">
                <process-notice-send
                  :bounds="bounds"
                  :bound="bound"
                  :boundIndex="boundIndex"
                  :nodes="allNodes"
                  :connections='allconnections'
                  :currentNodeId="currentNode.id"
                  @saveBound='saveBound'
                >
                </process-notice-send>
              </div>
            </div>
             <!-- 流转的组件 -->
            <div class="connection-component" v-else>
              <div v-for="(connection, connectionIndex) in connections" :key="connection.id">
                <process-easy-connection
                  :connection="connection"
                  :connectionIndex="connectionIndex"
                  :nodes="allNodes"
                  :currentNodeId="currentNode.id"
                  @openDialogInform="openDialogInform">
                </process-easy-connection>
            </div>
           </div>
          </el-main>
        </el-container>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="publishCancel()">取 消</el-button>
        <el-button type="primary" @click="publishConfirm()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="自定义候选人" v-if="selectPersonDialog.dialogVisible" :visible.sync="selectPersonDialog.dialogVisible" width="45%" :close-on-click-modal="false">
      <select-person v-if="selectPersonDialog.selectType==='user'" :remoteSearch="true" :treeData="selectPersonDialog.allPerson" :select="selectPersonDialog.node.candidates" ref="select" :isRadio="'radio'" :type="'group'"></select-person>

      <el-form :inline="true" class="show-node-form">
        <el-form-item label="选择节点">
          <el-select v-model="showNode" multiple collapse-tags>
            <el-option
              v-for="item in getAllNodes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="required">必填</el-checkbox>
          <label class="explain">(已选择的候选人都可以处理该节点)</label>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="selectPersonDialog.dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSelectPerson">确定</el-button>
      </div>
    </el-dialog>
    <process-easy-dialog-inform v-if="informDialog&&informDialog.dialogVisible"
                          :inform="informDialog"
                          :nodes="allNodes"
                          :isDisabled="true"
                          :connections="connections"
                          @setNotice="setNotice">
    </process-easy-dialog-inform>
  </el-container>
</template>
<script>
import SelectPerson from '../../system/select-person'
import ProcessEasyConnection from './process-easy-connection.vue'
import ProcessEasyDialogInform from './process-easy-dialog-inform'
import ProcessNoticeSend from './process-notice-send'
import _ from 'lodash'
export default {
  name: 'processCandidate',
  data () {
    return {
      conditions: { keyword: '', processCategory: '' },
      pagination: { currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0 },
      loading: false,
      items: [],
      options: [],
      filters: {},
      setCandidateBox: false,
      processName: '',
      candidateTypes: [{
        value: 'starter',
        label: '发起人'
      }, {
        value: 'superiors',
        label: '直属上级'
      }, {
        value: 'user',
        label: '自定义'
      }, {
        value: 'component',
        label: '来源控件'
      }],
      nodeList: [],
      currentProcessId: '',
      selectPersonDialog: {
        dialogVisible: false,
        node: {},
        allPerson: []
      },
      allNodes: [],
      showNode: [],
      required: true,
      // 候选人数据是否加载中,防止重复请求
      isLoadingCandidate: false,
      allconnections: [],
      currentNode: {},
      informDialog: null,
      startNodeId: '',
      bounds: []
    }
  },
  components: {
    SelectPerson,
    ProcessEasyConnection,
    ProcessEasyDialogInform,
    ProcessNoticeSend
  },
  created () {
    this.getTableData()
    this.loadCategory()
  },
  computed: {
    getAllNodes () {
      return this.allNodes.filter(m => {
        return m.type !== 'endEvent' && m.type !== 'cancelEvent'
      })
    },
    connections () {
      if (this.currentNode.type === 'noticeUserTask') {
        return []
      } else {
        return _.cloneDeep(this.allconnections.filter(m => m.sourceNodeId === this.currentNode.id))
      }
    }

  },
  methods: {
    getNodeName (nodeId) {
      return this.allNodes.find(m => m.id === nodeId).name
    },
    currentNodeTypeLabel (type) {
      return this.candidateTypes.find(n => n.value === type).label
    },
    getNodesByprocessId (currentProcessId) {
      return new Promise((resolve) => {
        this.$axios.get(`/process-api/processes/nodeCandidate/${currentProcessId}`).then(res => {
          resolve(res.data)
        })
      })
    },
    setCandidate (row) {
      this.isLoadingCandidate = true
      this.processName = row.name
      this.nodeList = []
      this.currentProcessId = row.currentProcessId
      this.getNodesByprocessId(row.currentProcessId).then((data) => {
        this.startNodeId = data[0].startNodeId

        this.isLoadingCandidate = false
        this.allNodes = data.map(m => m.node)
        this.allconnections = [].concat.apply([], this.$_.cloneDeep(data.map(m => m.connections)))
        let nodes = data.map(m => m.node).filter(m => {
          return m.type !== 'endEvent' && m.type !== 'cancelEvent' && m.type !== 'inclusiveGateway_start' && m.type !== 'inclusiveGateway_end'
        })
        let currentNodeName = []
        nodes.forEach(n => {
          if (n.bounds) {
            n.bounds = JSON.parse(n.bounds)
          }
          this.$set(n, 'candidateType', 'starter')
          if (n.candidates && n.candidates.length > 0) {
            if (n.candidates[0].type === 'starter') {
              n.candidateType = 'starter'
            } else if (n.candidates[0].type === 'superiors') {
              n.candidateType = 'superiors'
            } else if (n.candidates[0].type === 'component') {
              n.candidateType = 'component'
            } else {
              n.candidateType = 'user'
            }
            currentNodeName = []
            n.candidates.forEach(m => {
              currentNodeName.push(m.name)
            })
            n.text = currentNodeName.length !== 0 && currentNodeName.join('、')
          } else {
            n.candidateType = 'starter'
            n.candidates.push({
              'processId': row.currentProcessId,
              'nodeId': n.id,
              'targetId': '',
              'name': '',
              'type': 'starter',
              'defaultValue': ''
            })
          }
          this.nodeList.push(n)
          this.currentNode = this.nodeList[0]
          this.setCandidateBox = true
        })
      }).catch(() => {
        this.isLoadingCandidate = false
      })
    },
    publishCancel () {
      this.setCandidateBox = false
      this.getTableData()
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getTableData()
    },
    saveSelectPerson (param) {
      let select = []
      let text = []
      let node = this.nodeList.find(m => m.id === this.selectPersonDialog.node.id)
      if (this.selectPersonDialog.selectType === 'superiors') {
        select = [{'targetId': '',
          'name': '',
          'type': 'superiors',
          defaultValue: false,
          'processId': this.currentProcessId,
          'nodeId': this.selectPersonDialog.node.id }]
      } else {
        let radio = this.$refs.select.getDefault()
        this.$refs.select.getSelectedList().forEach(m => {
          select.push({
            'processId': this.currentProcessId,
            'nodeId': this.selectPersonDialog.node.id,
            'targetId': m.id,
            'name': m.name,
            'type': m.type,
            'defaultValue': radio === m.id
          })
          text.push(m.name)
        })
        node.text = text.length !== 0 && text.join('、')
      }
      node.candidates = select
      node.candidateRequired = this.required
      node.candidateShowNode = this.showNode.join(', ')
      this.selectPersonDialog.dialogVisible = false
    },
    changeCandidate (id, type) {
      let node = this.nodeList.find(m => m.id === id)
      if (type === 'user') {
        node.candidates = []
        node.candidateShowNode = ''
      } else {
        node.candidates = []
        node.candidates = [{
          'processId': this.currentProcessId,
          'nodeId': id,
          'targetId': '',
          'name': '',
          'type': type,
          'defaultValue': ''
        }]
        node.candidateShowNode = ''
      }
      node.text = ''
    },
    selectPerson (nodeId, type) {
      this.selectPersonDialog.selectType = type

      this.selectPersonDialog.node = this.nodeList.find(m => m.id === nodeId)
      this.showNode = this.selectPersonDialog.node.candidateShowNode ? this.selectPersonDialog.node.candidateShowNode.split(', ') : [this.getAllNodes[0].id]
      this.required = this.selectPersonDialog.node.candidateRequired
      this.selectPersonDialog.dialogVisible = true
    },
    publishConfirm () {
      let candidateList = []
      let showNodeList = []
      let flag = false
      let nodeWithNoticeUserTask = []
      this.nodeList.forEach(n => {
        if (n.candidates.length !== 0) {
          showNodeList.push({nodeId: n.id, candidateShowNode: n.candidateShowNode, candidateRequired: n.candidateRequired})
          n.candidates.forEach(m => {
            candidateList.push(m)
          })
        } else {
          flag = true
        }
        if (n.type === 'noticeUserTask') {
          n.bounds = JSON.stringify(n.bounds)
          nodeWithNoticeUserTask.push(n)
        }
      })
      if (this.nodeList.length !== 0) {
        if (!flag) {
          // 保存候选人
          // 保存展示节点和是否必填
          // 保存线
          this.$axios.post('/process-api/processes/changeCandidates', candidateList)
            .then(() => this.$axios.post('/process-api/processes/changeShowNode', showNodeList))
            .then(() => this.$axios.post('/process-api/processes/changeConnections', this.allconnections))
            .then(() => this.$axios.post('/process-api/processes/changeNoticeNodes', nodeWithNoticeUserTask))
            .then(() => {
              this.setCandidateBox = false
              this.getTableData()
            })
        } else {
          this.$message.error('请选择至少一个节点候选人')
        }
      } else {
        this.setCandidateBox = false
        this.getTableData()
      }
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.conditions.keyword,
        'category': this.conditions.processCategory
      }
      this.getTableData()
    },
    loadCategory () {
      this.$axios.get('/process-api/processes/categorys').then(res => {
        this.options = res.data
      })
    },

    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters
      this.$axios.get('/process-api/processes', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          this.loading = false
          this.items = res.data.items
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
          }
        }).catch(() => {
          this.loading = false
        })
    },
    changeNode (node) {
      this.currentNode = node
      if (node.type === 'noticeUserTask') {
        this.bounds = _.cloneDeep(node.bounds)
      } else {
        this.bounds = []
      }
    },
    openDialogInform (inform) {
      this.informDialog = this.$_.cloneDeep(inform)
      this.informDialog.notice.forEach(m => {
        m.ways = m.ways instanceof Array ? m.ways : JSON.parse(m.ways)
        m.targetNode = m.targetNode instanceof Array ? m.targetNode : JSON.parse(m.targetNode)
        m.targetUser = m.targetUser instanceof Array ? m.targetUser : JSON.parse(m.targetUser)
        m.targetComponent = m.targetComponent instanceof Array ? m.targetComponent : JSON.parse(m.targetComponent)
      })
    },
    setNotice (inform) {
      let connection = this.allconnections.find(m => m.id === inform.connectionId)
      if (connection) {
        connection.notice = inform.notice
      }
    },
    saveBound (object) {
      this.currentNode.bounds[object.boundIndex] = object.bound
    }
  }
}
</script>
<style lang="scss">
  .table-list {
   height: 100%;

   .el-table__row .cell .el-select {
     .el-input {
       width: 90px;
     }
   }
 }

 .fontRed {
   color: red;
 }

 .candidate-manege-dialog {
   .el-dialog {
     min-width: 750px;
   }

   .candidate-set {
     overflow: auto;

     .title {
       text-align: center;
       margin-bottom: 15px;

       b {
         font-size: 20px;
       }
     }

     .aside {
       max-height: 400px;
       min-height: 200px;
       overflow-y: scroll;
      .el-card  {
        cursor: pointer;
        &:hover{
          background: #F4F9FD;
        }
        &.is-always-shadow {
        background: var(--light-9, #EBF5FF);
        }
      }
       .candidates {
         overflow: hidden;

         span {
           float: left;
         }

         span.info {
           float: left;
           display: inline-block;
           overflow: hidden;
           width: 50%;
           text-overflow: ellipsis;
           white-space: nowrap;
           margin-right: 20px;
           margin-left: 20px;
           &.main-info {
             margin-top: 2px;
           }
         }

       }

       ul {
         margin-left: 30px;

         li {
           margin-bottom: 20px;
         }
       }

       label {
         display: inline-block;
         width: 100%;
         text-align: left;
       }

     }

     .main {
       min-height: 200px;
       margin-left: 20px;
       max-height: 400px;
       overflow-y: scroll;
       border: 1px solid #EBEEF5;

       .main-header {
         padding: 10px 0;
         overflow: hidden;

         .node-title {
            padding: 3px;
            float: left;
         }
         >.el-select{
            float: left;
            margin-right: 15px;
            width: 120px;
         }
         .main-info {
           float: left;
           margin-top: 2px;
           display: inline-block;
           margin-right: 20px;
           margin-left: 5px;
           width: 200px;
           overflow: hidden;
           text-overflow: ellipsis;
           white-space: nowrap;
         }

         .el-button {
           float: left;
           padding: 4px 10px;
         }
       }
     }

   }

 }

 .show-node-form {
   width: 600px;
   margin: 0 auto;
   margin-top: 10px;
 }

 @import '@/assets/scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/components/process/design/candidate-manege.vue